<template>
  <basic-form
    ref="thirdPartyBillInfo"
    title="Third Party Freight Charges Bill To"
    :mode="mode"
    :form-params="whatToShow"
    @input.native="getInfo"
    @numberInput="getInfo"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:actions>
      <el-button
        size="small"
        type="primary"
        plain
        @click="editing = true"
        v-if="!editing"
      >
        Edit
      </el-button>
      <el-button
        size="small"
        type="primary"
        plain
        @click="saveThirdPartyBillInfo"
        v-if="editing"
      >
        Save
      </el-button>
      <el-button
        size="small"
        type="danger"
        plain
        @click="
          value => {
            editing = false
            reset()
          }
        "
        v-if="editing"
      >
        Cancel
      </el-button>
    </template>
  </basic-form>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// models
import {
  ThirdPartyBillInfoWrapUp,
  ThirdPartyBillInfoModifyForm
} from '@/core/models/shipment'
// components
import BasicForm from '@/components/common/BasicForm.vue'
import { modifyShipment } from '@/api/shipment'
// msg
import PagesMessage from '@/core/message/pages'
export default {
  name: 'TruckInfo',
  props: {
    thirdPartyBillInfo: {
      type: Object,
      default: null
    },
    shipmentId: {
      type: String,
      required: true
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    }
  },
  components: {
    BasicForm
  },
  data() {
    return {
      editing: false
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return ThirdPartyBillInfoWrapUp(this.thirdPartyBillInfo)
    },
    editInfo() {
      const form = cloneDeep(ThirdPartyBillInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.thirdPartyBillInfo
          ? this.thirdPartyBillInfo[one.key]
          : ''
      })
      return form
    }
  },
  methods: {
    saveThirdPartyBillInfo() {
      const [passed, billInfo] =
        this.$refs.thirdPartyBillInfo.validateAllInputs()
      if (passed) {
        this.$confirm(
          'Update Third Party Freight Charges Bill Info?',
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          modifyShipment(this.shipmentId, { billTo: billInfo }).then(res => {
            this.editing = false
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_BOL)
          })
        })
      }
    },
    getInfo(e) {
      this.$emit('input', this.$refs.thirdPartyBillInfo.validateAllInputs()[1])
    },
    reset() {
      this.$emit('resetThirdPartyBillInfo')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
